// A névváltozás naplójának megjelenítése (D-010, v185): a tag saját előzménye a profilon, az admin egy tag előzménye a tagnyilvántartásban.
// A szerver csak a megőrzési időn belüli bejegyzéseket adja (24 hónap); itt csak kirajzolás.

import { t, localeFor } from "./i18n.js";
import { el } from "./dom.js";

const MEZO_KULCS = { name: "profile.name", nameLatn: "profile.nameLatn", nameJa: "profile.nameJa", nameZh: "profile.nameZh", nameKo: "profile.nameKo", nameCyr: "profile.nameCyr", nameEl: "profile.nameEl" };

/** @param {string} uiLang @param {Array<{at:number, changes:object}>} entries @returns {HTMLElement} */
export function renderNevNaplo(uiLang, entries) {
  const doboz = el("div", { class: "name-log" });
  if (!Array.isArray(entries) || entries.length === 0) {
    doboz.appendChild(el("p", { class: "hint name-log-none", text: t(uiLang, "nameLog.none") }));
    return doboz;
  }
  for (const bejegyzes of entries) {
    const sor = el("div", { class: "name-log-entry" });
    sor.appendChild(el("div", { class: "name-log-date", text: new Date(bejegyzes.at).toLocaleString(localeFor(uiLang)) }));
    for (const [mezo, v] of Object.entries(bejegyzes.changes || {})) {
      const cim = MEZO_KULCS[mezo] ? t(uiLang, MEZO_KULCS[mezo]) : mezo;
      const regi = v && typeof v.old === "string" && v.old !== "" ? v.old : "—";
      const uj = v && typeof v.new === "string" && v.new !== "" ? v.new : "—";
      sor.appendChild(el("div", { class: "name-log-change", text: `${cim}: ${regi} → ${uj}` }));
    }
    doboz.appendChild(sor);
  }
  return doboz;
}
